import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import AdmissionForm from "../components/AdmissionForm";
import AdmissionForm2 from "../components/AdmissionForm2";
import AdmissionForm3 from "../components/AdmissionForm3";
import AdmissionForm4 from "../components/AdmissionForm4";
import AdmissionForm6 from "../components/AdmissionForm6";
import CustomizedTabs from "../components/CommonTab";
import Spinner from "../components/Spinner";
import Acknowledgment from "../pages/Acknowledgment";
import CivilIdDocument from "../pages/CivilIdDocument";
import CivilNumberVerification from "../pages/CivilNumberVerification";
import EmailVerification from "../pages/EmailVerification";
import FinalPolicyPreview from "../pages/FinalPolicyPreview";
import SubmitPage from "../pages/SubmitPage";
import SuccessPage from "../pages/SuccessPage";
import { BASE_URL } from "../utils/config";
import { initialFormData } from "../utils/formData";
import { validateForm } from '../utils/validateForm';

function AdmissionFormPage() {
  // --------- ADMISSION TOGGLE ---------
  const isAdmissionsOpen = true; // <-- CHANGE TO true TO REOPEN ADMISSIONS
  // ------------------------------------

  const steps = [
    "PERSONAL",
    "FAMILY",
    "HEALTH",
    "ACADEMIC",
    "EMERGENCY",
    "DOCUMENT"
  ];

  const [step, setStep] = useState(-3);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [showError, setShowError] = useState(false);
  const [documentError, setDocumentError] = useState(false);
  const [documentErrorMsg, setDocumentErrorMsg] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e, firstKey, secondKey, thirdKey, forthKey) => {
    if (e.persist) e.persist();
    console.log(e);
    setFormData((currentData) => {
      let value;
      const { type } = e.target;
      if (type === "text") {
        value =
          e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
      } else {
        value = e.target.value;
      }


      console.log(value);

      const data = { ...currentData };
      let updateData = data;
      console.log(firstKey);
      console.log(updateData[firstKey]);

      if (firstKey) {
        updateData = updateData[firstKey];
      }

      if (secondKey) {
        updateData = updateData[secondKey];
      }

      if (thirdKey) {
        updateData = updateData[thirdKey];
      }
      if (forthKey) {
        updateData = updateData[forthKey];
      }


      updateData.value = value;

      localStorage.setItem("FormData", JSON.stringify(formData));
      return data;
    });
  };

  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      return obj
        .map(cleanObject)
        .filter(item => item !== null && item !== '' && !(typeof item === 'object' && Object.keys(item).length === 0));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        const cleaned = cleanObject(obj[key]);
        if (
          cleaned !== null &&
          cleaned !== '' &&
          !(typeof cleaned === 'object' && Object.keys(cleaned).length === 0)
        ) {
          newObj[key] = cleaned;
        }
      }
      return newObj;
    } else {
      return obj;
    }
  }


  useEffect(() => {
    if (Object.keys(errors)?.length > 0) {
      setShowError(false);
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step <= 7) {
      const isValid = validateForm(formData, setErrors, step);
      // const isValid = true;

      console.log(step, isValid);

      if (isValid) {
        if (step === 7) {
          submitForm();
        } else {
          setStep(step + 1);
        }
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
        setShowError(true);
        console.log(
          "Form has errors. Please fill in all required fields.",
          errors
        );
      }
    } else {
    }
  };

  const submitForm = async () => {
    let archivements = {};

    formData.archivements.value?.forEach((data, index) => {
      if (formData.archivements.value.length > 0) {
        archivements[index] = data.value;
      }
    });

    setIsLoading(true);

    try {
      const uploadData = {
        applicationType: "BDM",
        applicationYear: new Date().getFullYear(),

        firstName: formData.firstName.value,
        middleName: formData.middleName.value,
        lastName: formData.lastName.value,
        firstNameArabic: formData.arabicFirstName.value,
        middleNameArabic: formData.arabicMiddleName.value,
        lastNameArabic: formData.arabicLastName.value,
        dob: formData.dob.value,
        gender: formData.gender.value,
        maritalStatus: formData.maritalStatus.value,
        civilId: formData.civilId.value,

        nationality: formData.nationality.value,
        birthCountry: formData.birthCountry.value,
        passport: formData.passport.value,
        validityOfRes: formData.validityOfRes.value,
        securityCard: formData.securityCard.value,
        civilIdExpiry: formData.validityOfRes.value,


        address: {
          home: formData.address.home.value,
          block: formData.address.block.value,
          street: formData.address.street.value,
          appartment: formData.address.appartment.value,
          area: formData.address.area.value,
          jaddah: formData.address.jaddah.value,
          country: formData.address.country.value,
          po: formData.address.po.value,
          zipCode: formData.address.zipCode.value,
          governorate: formData.address.governorate.value
        },


        // civilIdExpiry: formData.civilIdExpiryDate.value,
        mobileOne: formData.mobileOne.value,
        mobileTwo: formData.mobileTwo.value,
        homeTelOne: formData.homeTelOne.value,
        homeTelTwo: formData.homeTelTwo.value,
        workTelOne: formData.workTel.value,
        taxTel: formData.homeTelTwo.value,
        emailOne: formData.emailOne.value,

        family: {
          fatherName: formData.family.fatherName.value,
          fatherNameArabic: formData.family.arabicFatherName.value,
          fatherDob: formData.family.fatherDob.value,
          fatherNationality: formData.family.fatherNationality.value,
          fatherCivilId: formData.family.fatherCivilId.value,
          fatherOccup: formData.family.fatherOccup.value,
          fatherEmployer: formData.family.fatherEmployer.value,
          fatherMobile: formData.family.fatherMobile.value,
          fatherWorkTel: formData.family.fatherWorkTel.value,
          fatherEmail: formData.family.fatherEmail.value,

          motherName: formData.family.motherName.value,
          motherNameArabic: formData.family.arabicMotherName.value,
          motherDob: formData.family.motherDob.value,
          motherNationality: formData.family.motherNationality.value,
          motherCivilId: formData.family.motherCivilId.value,
          motherOccup: formData.family.motherOccup.value,
          motherEmployer: formData.family.motherEmployer.value,
          motherMobile: formData.family.motherMobile.value,
          motherWorkTel: formData.family.motherWorkTel.value,
          motherEmail: formData.family.motherEmail.value
        },

        sponsorship: Object.keys(formData.sponsorship.value || {})?.[0],
        sponsorshipOtherNote: formData.sponsorshipOtherNote.value,
        sponsorshipNote: formData.sponsorshipScholarshipNote.value,

        isHealthRecord: formData.isHealthRecord.value,
        healthNote: formData.healthNote.value,
        isSuspended: formData.isSuspended.value,
        suspensionNote: formData.suspensionNote.value,

        archivements: formData.isAcademic.value ? archivements : {},


        education: [
          ...formData.school.value?.map((data) => ({
            name: data.name.value,
            type: "school",
            gpa: data.gpa.value,
            date: data.date.value,
            degree: data.degree.value
          })),
          ...(formData.isCollege.value
            ? formData.college.value?.map((data) => ({
              name: data.name.value,
              type: "college",
              country: data.country.value,
              gpa: data.gpa.value,
              date: data.date.value,
              major: data.major.value,
              degree: data.degree.value
            }))
            : [])
        ],

        emergency: [
          {
            name: formData.emergency[0].name.value,
            contact: formData.emergency[0].contact.value,
            relationship: formData.emergency[0].relationship.value,
            civilId: formData.emergency[0].civilId.value
          },
          {
            name: formData.emergency[1].name.value,
            contact: formData.emergency[1].contact.value,
            relationship: formData.emergency[1].relationship.value,
            civilId: formData.emergency[1].civilId.value
          }
        ],
        relatives: formData.relatives.selected.value,
        relativesNote:
          formData.relatives.selected.value === "kuwait university" ||
            formData.relatives.selected.value === "mohe"
            ? formData.relativesNote.value
            : null,
        eligible: formData.eligible.value
      };

      const cleaned = cleanObject(uploadData);

      const response = await fetch(
        `${BASE_URL}/student/admission/application-one`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ ...cleaned })
        }
      );

      const result = await response.json();
      console.log("RESULT", result);

      if (result.status) {
        // setStudentID(result.data.id);
        // setStudentName(uploadData.firstNameArabic);
        const docFile = new FormData();
        console.log("INITIALIZE", docFile);

        docFile.append("id", `${result.data.id}`);
        docFile.append("photograph", formData.document.photograph.value);
        docFile.append("transcript", formData.document.transcript.value);
        docFile.append("englishscore", formData.document.englishscore.value);
        docFile.append("highschool", formData.document.highschool.value);
        docFile.append("civilidFront", formData.document.civilidFront.value);
        docFile.append("civilidBack", formData.document.civilidBack.value);
        docFile.append("securityCardFront", formData.document.securityCardFront.value);
        docFile.append("securityCardBack", formData.document.securityCardBack.value);
        docFile.append("passport", formData.document.passport.value);
        docFile.append("record", formData.document.record.value);
        docFile.append("goodconduct", formData.document.goodconduct.value);
        docFile.append("fatherCivilId", formData.document.fatherCivilId.value);
        docFile.append("motherCivilId", formData.document.motherCivilId.value);
        docFile.append("sahel", formData.document.sahel.value);

        let docFileLen = 0;
        for (const entry of docFile.entries()) {
          console.log(entry[0], entry[1]);
          docFileLen++;
        }
        const isFormDataEmpty = docFileLen === 0;
        console.log("Is FormData Empty:", isFormDataEmpty);

        if (isFormDataEmpty) {
          setStep(5);
        } else {
          try {
            for (let [key, value] of docFile.entries()) {
              if (value === null || value === undefined) {
                docFile.delete(key);
              }
            }

            const docResponse = await fetch(
              `${BASE_URL}/student/admission/document/`,
              {
                method: "POST",
                body: docFile
              }
            );

            const jsonDoc = await docResponse.json();
            console.log(jsonDoc);

            if (jsonDoc.status) {
              toast.success("Form submitted successfully!");
              setStep(-3);
              setFormData(initialFormData);
              localStorage.removeItem("FormData");
            } else {
              setStep(-3);
              setDocumentError(true);
              setDocumentErrorMsg(jsonDoc.message);
            }
          } catch (docError) {
            console.error("Document upload failed:", docError);
            setStep(-3);
          }
        }
      } else {
        toast.error("Form submission failed!");
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Form submission failed!", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setStep(-3);
    localStorage.removeItem("otp");
    localStorage.removeItem("FormData");

    setFormData(initialFormData);
  };
  const handleBack = () => {
    setStep(step - 1 >= 0 ? step - 1 : 0);
  };
  const stepHandler = () => {
    setStep(step + 1);
  };

  useEffect(() => {
    if (localStorage.getItem("FormData")) {
      setFormData({
        ...JSON.parse(localStorage.getItem("FormData")),
        document: formData.document
      });
    }
    return () => {
      localStorage.removeItem("otp");
    };
  }, [formData.document]);

  // CLOSED ADMISSIONS SCREEN
  if (!isAdmissionsOpen) {
    return (
      <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center p-6 font-sans">
        <div className="bg-white shadow-2xl rounded-3xl overflow-hidden max-w-lg w-full">
          <div className="h-4 bg-[#b60041]"></div>
          <div className="p-10 text-center">
            <div className="mb-6 inline-flex items-center justify-center w-20 h-20 bg-red-50 rounded-full">
              <svg className="w-10 h-10 text-[#b60041]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h1 className="text-4xl font-extrabold text-slate-800 mb-4 tracking-tight">Admissions Closed</h1>
            <div className="w-16 h-1 bg-[#b60041] mx-auto mb-6 rounded-full"></div>
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              Thank you for your interest. <br/>
              <b>Admissions for the 2026/2027 Academic Year are currently closed.</b>
            </p>
            <p className="text-sm text-slate-400 italic bg-slate-50 py-3 rounded-lg border border-slate-100">
              Please check back later for updates.
            </p>
          </div>
          <div className="bg-slate-50 px-10 py-4 text-center border-t border-slate-100 italic text-slate-400 text-xs text-uppercase">
            AUMS • Academic Excellence
          </div>
        </div>
      </div>
    );
  }

  // ACTIVE ADMISSIONS WORKFLOW
  return (
    <div className="">
      {
        step === -3 ?
          (
            <Acknowledgment stepHandler={stepHandler} />
          )
          :
          step === -2 ?
            (
              <CivilNumberVerification
                civilId={formData.civilId}
                handleChange={handleChange}
                stepHandler={stepHandler}
              />
            )
            :
            step === -1 ?
              (
                <EmailVerification
                  stepHandler={stepHandler}
                  email={formData.emailOne}
                  handleChange={handleChange}
                />
              )
              :
              step >= 0 && step <= 5 ?
                (
                  <>
                    <CustomizedTabs steps={steps} value={step} />
                    <form onSubmit={handleSubmit}>
                      {step === 0 ? (
                        <AdmissionForm
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 1 ? (
                        <AdmissionForm2
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 2 ? (
                        <AdmissionForm3
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 3 ? (
                        <AdmissionForm4
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 4 ? (
                        <AdmissionForm6
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 5 ? (
                        <CivilIdDocument
                          showError={showError}
                          documentError={documentError}
                          documentErrorMsg={documentErrorMsg}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) :
                        null}
                      <Box style={{ height: "4rem" }}></Box>
                      <Box className="submitContainer border-t-[1px] border-t-[#b60041]">
                        <Button className={"cancelButton"} onClick={handleCancel}>
                          Cancel
                        </Button>
                        {step > 0 ? (
                          <Button className={"cancelButton"} onClick={handleBack}>
                            Back
                          </Button>
                        ) : null}
                        <Button
                          disabled={false}
                          className={"submitButton disabled:bg-red-100 "}
                          type="submit"
                        >
                          Next
                        </Button>
                      </Box>
                    </form>
                  </>
                )
                :
                step >= 6 ? (
                  <form onSubmit={handleSubmit}>
                    {step === 6 ? (
                      <>
                        <SubmitPage
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                          handleSubmit={stepHandler}
                          handleBack={handleBack}
                        />
                      </>
                    ) : step === 7 ? (
                      <>
                        <FinalPolicyPreview 
                          formData={formData} 
                          handleBack={handleBack} 
                          handleSubmit={handleSubmit} 
                        />
                        {isLoading && <Spinner />}
                      </>
                    ) : step === 8 ? (
                      <SuccessPage />
                    ) : null}
                  </form>
                ) :
                  null
      }
      <ToastContainer />
    </div>
  );
}

export default AdmissionFormPage;
